export default "__VITE_ASSET__DshHLGWH__"